import { BulkStatusActions } from '@bo-components/simulations/steps/StepThreeFinalize/BulkStatusActions';
import type { GamePlayerProjectionTrading } from '@library/types/trading';

export interface ProjectionsHeaderProps {
  newAndChangedProjections: Array<GamePlayerProjectionTrading>;
  simProjections: Array<GamePlayerProjectionTrading>;
  statTypeName: string;
  updateProjection: ({
    change,
    initialProjection
  }: {
    change: GamePlayerProjectionTrading;
    initialProjection: GamePlayerProjectionTrading;
  }) => void;
}

export const ProjectionsHeader = ({
  newAndChangedProjections,
  simProjections,
  statTypeName,
  updateProjection
}: ProjectionsHeaderProps) => {
  return (
    <>
      <span className="text-soClean-180 font-heebo text-sm tracking-tight">
        Profile
      </span>
      <span className="text-soClean-180 font-heebo text-sm tracking-tight">
        Projection
      </span>
      <span className="text-soClean-180 font-heebo text-sm tracking-tight">
        Board time
      </span>
      <span className="text-soClean-180 font-heebo text-sm tracking-tight">
        Start time
      </span>
      <span className="text-soClean-180 font-heebo text-sm tracking-tight">
        Rank
      </span>

      <BulkStatusActions
        newAndChangedProjections={newAndChangedProjections}
        simProjections={simProjections}
        statTypeName={statTypeName}
        updateProjection={updateProjection}
      />
    </>
  );
};
